import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  NgModule,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges
} from '@angular/core';
import {ResizeService} from '../../utils/size-detector/resize.service';
import {Product} from '../../model/product';
import {CommonModule} from '@angular/common';
import {PipesModule} from '../../pipes/pipes.module';
import {LAZYLOAD_IMAGE_HOOKS, LazyLoadImageModule} from 'ng-lazyload-image';
import {ENABLE_DETAIL_VIEW, SHOW_DESCRIPTION_PREVIEW} from '../../providers/storeFront.providers';
import {Observable} from 'rxjs';
import {DrupalRouterModule} from '../../drupal-router/drupal-router.module';
import {ProductService} from '../product-list-variant/product.service';
import {RouterModule} from '@angular/router';
import {ProductListVariantModule} from '../product-list-variant/product-list-variant.component';
import {IS_XS} from '../../providers/ui.providers';
import {LazyLoadImageHooks} from "../../app.module";

@Component({
  selector: 'app-product-list-item',
  templateUrl: './product-list-item.component.html',
  styleUrls: ['./product-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ProductService]
})
export class ProductListItemComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  @Input()
  product: Product;

  @Input()
  path: string;

  @Input()
  queryParams: any;

  @Output()
  created: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  images$: Observable<{ url: string, size: string }[]>;

  @Output()
  productClick: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public resizeService: ResizeService,
    private productService: ProductService,
    @Inject(ENABLE_DETAIL_VIEW) public enableDetailView$: Observable<boolean>,
    @Inject(SHOW_DESCRIPTION_PREVIEW) public showDescriptionPreview$: Observable<boolean>,
    @Inject(IS_XS) public isXs$: Observable<boolean>,
    private renderer2: Renderer2,
    private el: ElementRef
  ) {
    this.renderer2.addClass(this.el.nativeElement, 'loading');
  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.product) {
      this.productService.product = this.product;
      this.renderer2.removeClass(this.el.nativeElement, 'loading');
      this.renderer2.removeClass(this.el.nativeElement, 'loaded');
      this.renderer2.addClass(this.el.nativeElement, 'loaded');
    }
  }

  ngAfterViewInit(): void {
    this.created.emit();
  }

}

@NgModule({
  declarations: [
    ProductListItemComponent
  ],
  imports: [
    CommonModule,
    LazyLoadImageModule,
    PipesModule,
    ProductListVariantModule,
    DrupalRouterModule,
    RouterModule
  ],
  entryComponents: [],
  exports: [
    ProductListItemComponent
  ],
  providers: [
    {provide: LAZYLOAD_IMAGE_HOOKS, useClass: LazyLoadImageHooks}
  ]
})

export class ProductListItemModule {
}
